// angular
import { Injectable } from '@angular/core';

// addons
import { Observable } from 'rxjs';

// models
import { IUserSlim } from '@shared/models';

// services
import { ApiService } from './api.service';

@Injectable()
export class NotaryService {
  constructor(private apiService: ApiService) {}

  getNotaries(): Observable<IUserSlim[]> {
    return this.apiService.get('/notaries');
  }
}
